export const deserializeSkillLevel = (skillLevel: string) => {
  const [skillId, level] = skillLevel.split('-');
  return {
    skillId,
    level
  };
};
